import hiddenPrizeIcon from './hidden-prize-200.svg?url';

export const getChallengeLockedPrizeIcons = (prizesLength: number): string[] => {
    return Array.from({ length: prizesLength }).map(() => hiddenPrizeIcon);
};
